import { IBookRadioIconInput, IBookRadioIconInputOption } from './types';
import { EBookInputType, TGetBookInput } from '../shared';

export const getBookRadioIconInputOptionData = ({
  imgSrc,
  value,
}: IBookRadioIconInputOption): IBookRadioIconInputOption => ({
  imgSrc,
  value,
})

export const getBookRadioIconInputData: TGetBookInput<IBookRadioIconInput>
  = (params) => ({
    ...params,
    type: EBookInputType.radioIcon,
  } as const);
